import React, { useState, useRef, useEffect } from 'react';
import style from './ReadMore.module.scss';
import { useWindowResize } from '@aperza/ui';
let defaultHeight = 85;
export const ReadMore = (props) => {
    let { text, className, more = 'More', less = 'Less', line = 4 } = props;
    let [showMore, setShowMore] = useState(false);
    let [collapseTextHeight, setCollapseTextHeight] = useState('76px');
    let [textHeight, setTextHeight] = useState('76px');
    const hiddenEl = useRef(null);
    const toggle = () => {
        setShowMore(!showMore);
    };
    const fullTextHeight = () => {
        return hiddenEl && hiddenEl.current ? hiddenEl.current.clientHeight : defaultHeight;
    };
    const checkCollapseTextHeight = () => {
        if (text != null) {
            let lineHeight = parseFloat($('#readmore').css('line-height'));
            setCollapseTextHeight(lineHeight * line + 'px');
        }
    };
    const resize = () => {
        let height = fullTextHeight();
        setTextHeight('' + height);
    };
    useWindowResize(resize);
    useEffect(() => {
        resize();
        checkCollapseTextHeight();
    }, [text]);
    return (React.createElement("div", { className: `${className} ${style.ReadMore}` },
        React.createElement("div", { className: style.text, style: {
                height: showMore ? textHeight : collapseTextHeight,
                transition: 'height 300ms',
            } },
            React.createElement("p", { id: "readmore", className: style.desc }, text)),
        fullTextHeight() >= defaultHeight && React.createElement("a", { onClick: toggle }, showMore ? less : more),
        React.createElement("div", { ref: hiddenEl, className: style.hidden },
            React.createElement("p", { className: style.desc }, text))));
};
